export const SET_SHOW_MORE_MENU = 'SET_SHOW_MORE_MENU';
export const HIDE_SHOW_MORE_MENU = 'HIDE_SHOW_MORE_MENU';
export const TOGGLE_SHOW_COMMUNITY_MENU = 'TOGGLE_SHOW_COMMUNITY_MENU';
export const TOGGLE_MENTIONS_MODAL = 'TOGGLE_MENTIONS_MODAL';
export const TOGGLE_SHOW_COMMUNITY_SELECT_MODAL =
  'TOGGLE_SHOW_COMMUNITY_SELECT_MODAL';
export const TOGGLE_REPLIES = 'TOGGLE_REPLIES';

export const setShowMoreMenu = (visibleMenuId) => ({
  type: SET_SHOW_MORE_MENU,
  payload: {
    visibleMenuId
  }
});

export const hideShowMoreMenu = () => ({
  type: HIDE_SHOW_MORE_MENU
});

export const toggleShowCommunityMenu = () => ({
  type: TOGGLE_SHOW_COMMUNITY_MENU
});

export const toggleShowCommunitySelectModal = (visible) => ({
  type: TOGGLE_SHOW_COMMUNITY_SELECT_MODAL,
  payload: { visible }
});

export const toggleMentionModal = (visible) => ({
  type: TOGGLE_MENTIONS_MODAL,
  payload: { visible }
});

// Used mainly for analytics
export const toggleReplies = ({
  contentId,
  communityId,
  showingReplies,
  numberOfReplies
}) => ({
  type: TOGGLE_REPLIES,
  payload: {
    contentId,
    communityId,
    showingReplies,
    numberOfReplies
  }
});
